import * as v from "valibot";
import { rpcContract } from "../rpc";

/**
 * Update subscription tier pricing (upsert)
 * Creates tier if doesn't exist, updates price if exists
 * Existing subscribers keep their current price when updated
 */
export const updateSubscriptionTierRpcContract = rpcContract({
  name: "update-subscription-tier",
  paramsSchema: v.object({
    newMonthlyPriceCents: v.pipe(v.number(), v.minValue(100), v.maxValue(99999)),
  }),
  resultSchema: v.object({
    tierId: v.string(),
    newPriceId: v.string(),
    newMonthlyPriceCents: v.number(),
    tierCreated: v.boolean(),
  }),
});

export type UpdateSubscriptionTierParams = v.InferOutput<(typeof updateSubscriptionTierRpcContract)["paramsSchema"]>;
export type UpdateSubscriptionTierResult = v.InferOutput<(typeof updateSubscriptionTierRpcContract)["resultSchema"]>;
